import { store } from "@/store";
import { Roles } from "@/helpers/enums/Roles";

export default [
  {
    path: "users-by-computers",
    component: () => import("@/views/pages/Assets/Computers/UsersByComputer.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "computers/:status",
    component: () => import("@/views/pages/Assets/Computers/List.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "computer/:computerGuid",
    name: "/computerDetail",
    component: () => import("@/views/pages/Computer/ComputerDetail.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "company/:companyId/sites",
    component: () => import("@/views/pages/Assets/BrowseAssets/SiteList.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "company/:companyId/sites/:siteGuid/groups",
    component: () => import("@/views/pages/Assets/BrowseAssets/GroupList.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "company/:companyId/sites/:siteGuid/groups/:groupGuid/computers",
    component: () =>
      import("@/views/pages/Assets/BrowseAssets/ComputerList.vue"),
    meta: {
      title: "assets",
    },
  },
  {
    path: "company/:companyId/sites/:siteGuid/groups/:groupGuid/computers/:computerGuid",
    component: () =>
      import("@/views/pages/Assets/BrowseAssets/ComputerDetail.vue"),
    meta: {
      title: "assets",
    },
  },

  {
    path: "company",
    component: () =>
      import("@/views/pages/Assets/Assets.vue"),
    meta: {
      title: "assets",
    }
  },
  {
    path: "manage",
    meta: {
      back: true,
      title: "assets",
      target: process.env.VUE_APP_AGMS_URL,
    },
    component: () => import("@/views/pages/Iframe.vue"),
  },
];
